import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Field, FieldArray, reduxForm, propTypes as formPropTypes } from 'redux-form';
import cloneDeep from 'lodash/cloneDeep';
import ReduxFormField from '../../common/forms/ReduxFormsField';
import CropperScaffold from '../../common/forms/CropperScaffold';
import ReduxFormsImageCropper from '../../common/forms/ReduxFormsImageCropper';
import VideoUploader from '../../common/components/VideoUploader';
import LessonVideoSections from './LessonVideoSections';

const validate = values => {
  const errors = {};
  const { name, video_sections } = values;

  if (video_sections && video_sections.length) {
    const sectionsErrors = [];
    // Allows for HH:MM:SS, H:MM:SS, MM:SS, M:SS, SS, S, up to 23:59:59
    const hmsRegex = /^(((([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5])|([0-5]?))[0-9]:)?[0-5]?[0-9]$/;

    video_sections.forEach((section, i) => {
      const sectionErrors = {};

      if (!section.text || !section.text.trim()) {
        sectionErrors.text = 'Title is required';
      } else if (section.text.trim().length > 255) {
        sectionErrors.text = 'Title cannot be longer than 255 characters';
      }

      if (!section || !section.startTime) {
        sectionErrors.startTime = 'Start time is required';
      } else if (!hmsRegex.test(section.startTime)) {
        sectionErrors.startTime = 'Invalid time format';
      }

      sectionsErrors[i] = sectionErrors;
    });

    if (sectionsErrors.length) {
      errors.video_sections = sectionsErrors;
    }
  }

  if (!name || !name.trim()) {
    errors.name = ['Name is required'];
  } else if (name.trim().length > 255) {
    errors.name = ['Name cannot be longer than 255 characters'];
  }

  return errors;
};

class LessonEditForm extends Component {
  static propTypes = {
    ...formPropTypes,
    clearOrigImage: PropTypes.bool.isRequired,
    lesson: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired,
    onVideoUpload: PropTypes.func.isRequired,
    removeImage: PropTypes.func.isRequired,
  };

  onSubmit = values => {
    const submitValues = cloneDeep(values);

    submitValues.name = submitValues.name.trim();
    submitValues.video_sections.forEach(section => {
      const times = section.startTime.split(':');
      let time = 0;
      for (let i = 0; times.length; i++) {
        switch (i) {
          case 0:
            time += parseInt(times.pop(), 10);
            break;
          case 1:
            time += 60 * parseInt(times.pop(), 10);
            break;
          case 2:
            time += 60 * 60 * parseInt(times.pop(), 10);
            break;
          default:
            break;
        }
      }
      section.text = section.text.trim();
      section.startTime = time;
    });

    return this.props.onSubmit(submitValues);
  };

  render() {
    const {
      clearOrigImage,
      lesson,
      handleSubmit,
      onCancel,
      onVideoUpload,
      lessonVideoUploading,
      lessonVideoUploadProgress,
      removeImage,
      submitting,
    } = this.props;

    return (
      <div className="admin-paper__edit-content">
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <Field name="name" component={ReduxFormField} label="Lesson Name" required={true}>
            <input type="text" />
          </Field>
          <VideoUploader
            onVideoUpload={onVideoUpload}
            uploading={lessonVideoUploading}
            uploadProgress={lessonVideoUploadProgress}
            video={lesson.get('video_id') ? lesson.get('video') : null}
            labelText="Lesson Video"
          />
          {lesson && lesson.get('image_id') && !clearOrigImage ? (
            <CropperScaffold label="Lesson Video Thumbnail" required>
              <div className="original-image">
                <img alt="lesson logo" src={lesson.getIn(['image', 'location'])} />
              </div>
              <div className="cropper-scaffold__controls">
                <button type="button" className="button button--theme--outline" onClick={removeImage}>
                  Remove Image
                </button>
              </div>
            </CropperScaffold>
          ) : (
            <Field name="image" component={ReduxFormsImageCropper} label="Lesson Video Thumbnail" />
          )}
          <FieldArray name="video_sections" component={LessonVideoSections} />
          <div className="admin-paper__lesson-row__buttons">
            <div>
              <button type="button" className="button button--theme--plain" onClick={onCancel} disabled={submitting}>
                Cancel
              </button>
              <button type="submit" className="button" disabled={submitting}>
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'lessonEditForm',
  onSubmitFail: () => {
    window.scrollTo(0, 0);
  },
  validate,
})(LessonEditForm);



// WEBPACK FOOTER //
// ./src/courses/lessons/LessonVideoEditForm.js